<template>
	<div>
		<b-table :items="incidentsListState"
				 :current-page="currentPage"
				 :per-page="perPage"
				 :fields="incidentTableFields"
				 :busy="loader"
				 show-empty
				 striped
				 i empty-filtered-text="No hay casos disponibles"
				 empty-text="No hay casos disponibles"
				 head-variant="light">
			<div slot="attentionDate" slot-scope="item">
				{{item.item.attentionDate | dateFormat}}
			</div>
			<div slot="detail" slot-scope="item">
				<router-link
					:to="{name: 'IncidentDetail', params: {id: item.item.incidentID}}">
					Ver
				</router-link>
			</div>

			<template v-slot:table-busy>
				<div class="text-center text-info my-2">
					<b-spinner class="align-middle"></b-spinner>
				</div>
			</template>
		</b-table>
		<nav class="d-flex justify-content-center" v-if="totalRows > perPage">
			<b-pagination
				:total-rows="totalRows"
				:per-page="perPage"
				v-model="currentPage"
				prev-text="<<"
				next-text=">>"
				hide-goto-end-buttons/>
		</nav>
	</div>
</template>

<script>
	export default {
		name: "IncidentTableComponent",
		props: {
			incidentsList: Array,
			loader: Boolean,
			incidentFields: {
				type: Object,
				require: false
			}
		},
		data: function () {
			return {
				perPage: 10,
				currentPage: 1,
				incidentsListState: [],
				incidentTableFields: {
					incidentName: {
						label: 'Título'
					},
					incidentNumber: {
						label: '#Caso'
					},
					ticketID: {
						label: '#Ticket'
					},
					tracking: {
						label: 'Seguimiento'
					},
					detail: {
						label: 'Detalles'
					}
				},
			}
		},
		mounted() {
			this.incidentsListState = this.incidentsList;
			if (this.incidentFields) {
				this.incidentTableFields = this.incidentFields;
			}
		},
		computed: {
			totalRows: function () {
				return this.incidentsListState.length;
			}
		}
	}
</script>

<style scoped>

</style>
